"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { type EcolabStories } from "types/ContentHub/Stories";

export type StoriesContextProps = {
  story?: EcolabStories;
  storiesSlug: string;
};

const StoriesContext = createContext<StoriesContextProps>({
  story: undefined,
  storiesSlug: "",
});

interface StoriesProviderProps {
  children: ReactNode;
  story?: EcolabStories;
  storySlug: string;
}

// Note: prop is named `stories` (plural) but the context value field is
// `story` (singular). Original behaviour preserved — the hook is also
// `useStoryContext` (singular). Worth normalising in a later pass.
export const StoryProvider = ({
  children,
  story,
  storySlug,
}: StoriesProviderProps) => {
  const contextValue = useMemo(
    () => ({ story: story, storiesSlug: storySlug }),
    [story, storySlug],
  );
  return (
    <StoriesContext.Provider value={contextValue}>
      {children}
    </StoriesContext.Provider>
  );
};

export const useStoryContext = (): StoriesContextProps =>
  useContext(StoriesContext);
